export default {
  setting: [],
  saleSetting: [],

  saleType: [],
  saleTypeById: {},
  saleTypeMaxCode: null,

  seller: [],
  sellerById: {},
  sellerMaxCode: null,

  salesAgents: [],
  salesAgentsById: {},
  salesAgentsMaxCode: null,

  salePricePolicy: [],
  salePricePolicyById: {},
  salePricePolicyCommodity: {},
  salePricePolicyDetail: [],
  salePricePolicyDetailById: {},
  salePricePolicyMaxCode: null,

  discountPolicy: [],
  discountPolicyById: {},
  discountPolicyDetail: [],
  discountPolicyDetailById: {},
  discountPolicyMaxCode: null,

  giftPolicy: [],
  giftPolicyById: {},
  giftPolicyDetail: [],
  giftPolicyDetailById: {},
  giftPolicyMaxCode: null,

  excelSample: [],
  excelSampleById: [],
  excelSampleDetail: [],
  excelSampleData: [],

  preFactor: [],
  preFactorById: {},
  preFactorMaxCode: null,
  preFactorAttachment: [],
  preFactorAttachmentById: null,
  preFactorNotes: [],

  saleFactor: [],
  saleFactorById: {},
  saleFactorMaxCode: null,
  saleFactorAttachment: [],
  saleFactorAttachmentById: {},
  saleNotes: [],
  saleFactorCommission: [],
  saleFactorCommissionById: {},

  returnSaleFactor: [],
  returnSaleFactorById: {},
  returnSaleFactorMaxCode: null,
  returnSaleFactorAttachment: [],
  returnSaleFactorAttachmentById: null,
  returnSaleFactorNotes: [],
  returnSaleFactorCommission: [],
  returnSaleFactorCommissionById: {},

  saleReportByProduct: [],

  salesOfficeReport: [],

  saleByAgentReport: [],
  saleByAgentDetailReport: [],

  comprehensiveSalesInvoiceReport: [],

  salesStatisticsByCustomersReport: [],

  salesQuantityReport: [],

  aggregatedCustomerProductSalesCustomerListReport: [],
  aggregatedCustomerProductSalesCommodityListReport: [],
  customerCommoditySaleReport: [],
  customerCommoditySaleFactorListReport: [],
  basedOnSaleManagerListReport: [],
  basedOnSaleManagerDetailReport: [],
  salesManagerCollaborationPercentageReport: [],
  reportOfCreditorsAndDebtorsBasedOnSalesManagers: [],
  customerSalesReportBasedOnSalesManagers: [],
  productProfitReport: [],
  grossProfitReport: [],
  productProfitByProductGroupReport: [],
  grossProfitByInvoiceProductCustomerReport: [],
  comprehensiveProductSalesReport: [],
  customerSalesSingleProductReport: [],
  awardsGrantedCommodityListReport: [],
  awardsGrantedReport: [],
  saleByVisitorList: [],
  saleByVisitorReport: [],
  addMinusReport: [],
  customerProfitReport: [],
  factorProfitReport: [],

  saleFactorManagementCartable: [],
  saleReturnManagementCartable: [],

  confirmSaleFactorCartable: [],
  confirmsaleReturnCartable: [],

  cartableLog: [],
};
